import React, { useState } from "react";

const DeleteAllPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showDeleteAllPopup, setShowDeleteAllPopup] =
      useState<boolean>(false);

    const deleteAllToggleHandler = () => {
      setShowDeleteAllPopup(!showDeleteAllPopup);
    };

    return (
      <Component
        showDeleteAllPopup={showDeleteAllPopup}
        deleteAllToggleHandler={deleteAllToggleHandler}
        {...props}
      />
    );
  };

export default DeleteAllPopupHOC;
